export function abstractConverter(actions, pressMap) {
  return actions.map(action => ({
    ...action,
    presses: action.presses.map(press => ({
      ...press,
      type: pressMap[press.type] || press.type
    }))
  }));
}
